<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title col-md-12">AI</div>
    @if (!loading) {
        <div class="col-md-12 well-content">
            <div class="panel panel-default">
                <div class="panel-heading">General</div>
                <div class="panel-body" style="display: flex; justify-content: center; width: 100%; margin-top: 15px">
                    <form style="max-width: 400px; width: 100%">
                        <h1
                            style="display: flex; align-items: center; justify-content: space-between"
                            class="h4 signin-title">
                            <div>AI Functionality:</div>
                            <div>
                                <app-toggle-switch
                                    [readonly]="aiReadonly"
                                    onLabel="On"
                                    offLabel="Off"
                                    [checked]="aiToggleOn"
                                    (click)="enable()"
                                    [autoToggle]="false">
                                </app-toggle-switch>
                            </div>
                        </h1>
                    </form>
                </div>
                @if (aiRequested) {
                    <div style="display: flex; justify-content: center; width: 100%; margin-bottom: 15px">
                        <h3 class="control-label">
                            AI functionality has been requested. A Sedona representative will contact you shortly.
                        </h3>
                    </div>
                }
            </div>
        </div>
    }
</div>
